
import { EMPTY_ITEM_THEME } from '../form/theme.js'
import { getFirstNonEmptyString }  from '../utils/lookup.js'

export default {
  /* tslint:disable */
  render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('div',{staticClass:"ae-form-field",class:[_vm.fieldTheme.classes, _vm.fieldStateClasses, { 'ae-sensitive': _vm.supportSensitive }],attrs:{"data-ae-form-field-changed":_vm.isChanged ? 'true' : null,"data-ae-form-field-name":_vm.fieldName || null},on:{"!input":function($event){return _vm.refreshFieldState.apply(null, arguments)},"!change":function($event){return _vm.refreshFieldState.apply(null, arguments)},"!focusout":function($event){return _vm.refreshFieldState.apply(null, arguments)}}},[_c('ae-layout',{staticClass:"ae-form-field__layout",attrs:{"param-field":_vm.field,"param-document":_vm.document,"param-form":_vm.formToUse,"param-theme":_vm.theme,"param-readonly":_vm.readonly || (_vm.field && _vm.field.isReadonly),"param-placeholder":_vm.placeholder,"param-field-validation-errors":_vm.fieldIssues,"layout-id":_vm.layoutToUseId,"watch-layout":_vm.watchLayout,"watch-layout-revisions":_vm.watchLayoutRevisions}}),_vm._v(" "),(_vm.hasIssues)?_c('div',{staticClass:"ae-form-field__validation",attrs:{"data-ae-form-field-validation":""}},[_vm._l((_vm.fieldIssueErrors),function(issue){return _c('div',{key:_vm.issueKey(issue, 'error'),staticClass:"ae-form-field__validation-message ae-form-field__validation-message--error",attrs:{"data-ae-form-field-validation-error":""}},[_vm._v(_vm._s(issue.message))])}),_vm._v(" "),_vm._l((_vm.fieldIssueWarnings),function(issue){return _c('div',{key:_vm.issueKey(issue, 'warning'),staticClass:"ae-form-field__validation-message ae-form-field__validation-message--warning",attrs:{"data-ae-form-field-validation-warning":""}},[_vm._v(_vm._s(issue.message))])})],2):_vm._e()],1):_vm._e()},
  staticRenderFns: [],
  /* tslint:enable */
  
  props: {
    field: {
      type: Object, // FormFieldAtPlaceholder
      required: true
    },
    document: {
      type: Object,
      required: true
    },
    form: Object,
    theme: Object,
    layoutId: String,
    watchLayout: {
      type: Boolean,
      default: true
    },
    watchLayoutRevisions: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: Object,
      default: null
    },
    fieldValidationErrors: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      fieldStateRevision: 0,
    }
  },
  computed: {
    supportSensitive() {
      const value = this.field?.controlParams?.supportSensitive
      const tag = this.formToUse?.getField?.(this.fieldName)?.tags?.sensitive ?? this.field?.tags?.sensitive
      return (tag != null && tag !== false && tag !== 'false') || value === true || value === 'true'
    },
    fieldTheme() {
      return this.theme?.field ?? EMPTY_ITEM_THEME
    },
    layoutToUseId() {
      return getFirstNonEmptyString(this.layoutId, this.fieldTheme.layoutId, '7f087b7f-c6a4-49d8-803a-4486341ae23d')
    },
    formToUse() {
      return this.form ?? this.document?.form
    },
    fieldName() {
      return this.field && this.field.name ? this.field.name : ''
    },
    isVisible() {
      const isVisible = this.field?.isVisible ?? true
      return isVisible && this.document && this.formToUse
    },
    fieldIssues() {
      return this.fieldValidationErrors?.[this.field?.name] ?? null
    },
    fieldIssueErrors() {
      return this.fieldIssues?.errors ?? []
    },
    fieldIssueWarnings() {
      return this.fieldIssues?.warnings ?? []
    },
    hasIssues() {
      return this.fieldIssueErrors.length > 0 || this.fieldIssueWarnings.length > 0
    },
    documentEditVersion() {
      return this.document?.editVersion || this.document?.v || ''
    },
    dirtyField() {
      // Touch the edit version so Vue recomputes after EditableDocument
      // mutations even though getDirtyFields() derives from internal state.
      const version = this.documentEditVersion
      const revision = this.fieldStateRevision
      void version
      void revision

      if (!this.document || typeof this.document.getDirtyFields !== 'function' || !this.fieldName) {
        return null
      }

      return this.document.getDirtyFields().find(field => field.name === this.fieldName) || null
    },
    isChanged() {
      return !!this.dirtyField
    },
    fieldStateClasses() {
      return {
        'ae-form-field--changed': this.isChanged,
      }
    },
    changedSummary() {
      const dirtyField = this.dirtyField

      if (!dirtyField) {
        return ''
      }

      if (dirtyField.reference) {
        const parts = []

        if (dirtyField.addedReferences?.length) {
          parts.push(`neu ${dirtyField.addedReferences.map(this.referenceLabel).join(', ')}`)
        }

        if (dirtyField.removedReferences?.length) {
          parts.push(`entfernt ${dirtyField.removedReferences.map(this.referenceLabel).join(', ')}`)
        }

        if (dirtyField.reorderedReferences?.length && !dirtyField.addedReferences?.length && !dirtyField.removedReferences?.length) {
          parts.push('Reihenfolge geändert')
        }

        if (parts.length) {
          return `Geändert · ${parts.join(' · ')}`
        }
      }

      return `Geändert · vorher ${dirtyField.before || '-'}`
    },
    changedTitle() {
      const dirtyField = this.dirtyField

      if (!dirtyField) {
        return ''
      }

      if (dirtyField.reference) {
        const parts = [`${dirtyField.label || dirtyField.name} wurde geändert.`]

        if (dirtyField.addedReferences?.length) {
          parts.push(`Neu: ${dirtyField.addedReferences.map(this.referenceLabel).join(', ')}`)
        }

        if (dirtyField.removedReferences?.length) {
          parts.push(`Entfernt: ${dirtyField.removedReferences.map(this.referenceLabel).join(', ')}`)
        }

        if (dirtyField.reorderedReferences?.length) {
          parts.push('Reihenfolge geändert.')
        }

        return parts.join('\n')
      }

      return `${dirtyField.label || dirtyField.name} wurde geändert.\nVorher: ${dirtyField.before || '-'}\nJetzt: ${dirtyField.after || '-'}`
    },
  },
  methods: {
    issueKey(issue, type) {
      const path = Array.isArray(issue.path) ? issue.path.join('.') : ''
      return `${type}:${issue.code || ''}:${path}:${issue.message}`
    },
    refreshFieldState() {
      this.fieldStateRevision += 1
    },
    referenceLabel(reference) {
      return reference?.text || reference?.id || '-'
    },
  }
}
